<ct-lib-toggle-card
  [title]="translationBase + '.title' | transloco"
  [description]="translationBase + '.description' | transloco"
  [checked]="enabled()"
  [disabled]="!canEnable() || busy()"
  [busy]="busy()"
  [switchAriaLabel]="translationBase + '.toggle' | transloco"
  (checkedChange)="onToggle($event)"
>
  @if (!canEnable()) {
    <p lead class="hint">
      {{ translationBase + '.payment-hint' | transloco }}
    </p>
  }

  <div class="setup" [formGroup]="form">
    <div class="fields">
      <div class="form-group form-floating">
        <ng-select
          class="form-control"
          [id]="instanceId + '-limit'"
          formControlName="limit"
          [items]="limits"
          bindValue="value"
          [clearable]="false"
          [searchable]="false"
          appendTo="body"
          [placeholder]="translationBase + '.limit-placeholder' | transloco"
        >
          <ng-template ng-label-tmp let-item="item">
            {{ item.labelKey | transloco }}
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            {{ item.labelKey | transloco }}
          </ng-template>
        </ng-select>
        <label [attr.for]="instanceId + '-limit'">
          {{ translationBase + '.limit-label' | transloco }}
        </label>
      </div>

      <div class="form-group form-floating">
        <ng-select
          class="form-control"
          [id]="instanceId + '-package'"
          formControlName="packageId"
          [items]="packages()"
          bindValue="id"
          [clearable]="false"
          [searchable]="false"
          appendTo="body"
          [placeholder]="translationBase + '.package-placeholder' | transloco"
        >
          <ng-template ng-label-tmp let-item="item">
            @if (item?.currency) {
              @if (item.credits > 0) {
                {{ item.credits | number: '1.0-0' }} Credits ·
              }
              {{
                item.unitAmountCents / 100
                  | currency: (item.currency ?? 'eur').toUpperCase()
              }}
            }
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            @if (item?.currency) {
              @if (item.credits > 0) {
                {{ item.credits | number: '1.0-0' }} Credits ·
              }
              {{
                item.unitAmountCents / 100
                  | currency: (item.currency ?? 'eur').toUpperCase()
              }}
            }
          </ng-template>
        </ng-select>
        <label [attr.for]="instanceId + '-package'">
          {{ translationBase + '.package-label' | transloco }}
        </label>
      </div>
    </div>

    @if (limited()) {
      <div class="quantity-block">
        <label class="quantity-label" [id]="instanceId + '-max-packages-label'">
          {{ translationBase + '.max-packages-label' | transloco }}
        </label>
        <div
          class="quantity"
          role="group"
          [attr.aria-labelledby]="instanceId + '-max-packages-label'"
        >
          @if (selectedPackage(); as pack) {
            <div class="quantity-copy">
              <span>
                {{
                  translationBase + '.quantity-credits'
                    | transloco
                      : {
                          count: multiplier(),
                          credits: pack.credits | number: '1.0-0',
                        }
                }}
              </span>
              <span class="quantity-total">
                {{
                  totalKey()
                    | transloco
                      : {
                          price:
                            (pack.unitAmountCents / 100) * multiplier()
                            | currency: (pack.currency ?? 'eur').toUpperCase(),
                        }
                }}
              </span>
            </div>
          }
          <app-number-stepper
            [value]="multiplier()"
            [min]="minPackages"
            (valueChange)="onMultiplierChange($event)"
          />
        </div>
      </div>
    }
  </div>
</ct-lib-toggle-card>

@if (showFormSaver()) {
  <ct-lib-form-saver
    #formSaver
    [form]="form"
    [busy]="busy()"
    (onSave)="onFormSaverSave()"
  ></ct-lib-form-saver>
}
